(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-redux"), require("amazon-cognito-identity-js"), require("aws-sdk/global"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-redux", "amazon-cognito-identity-js", "aws-sdk/global"], factory);
	else if(typeof exports === 'object')
		exports["ReactCognito"] = factory(require("react"), require("react-redux"), require("amazon-cognito-identity-js"), require("aws-sdk/global"));
	else
		root["ReactCognito"] = factory(root["React"], root["ReactRedux"], root["AmazonCognitoIdentity"], root["aws-sdk/global"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_9__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition